import type { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import { is3pProductKey } from '../constants/product-keys';
import { type ThirdPartyConfigsBootstrap } from '../constants/schemas/3p-config';

export const isProductImpersonated: (
	product: ProductKeys3P | undefined,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
) => boolean = (
	product: ProductKeys3P | undefined,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
): boolean => {
	return !!(product && is3pProductKey(product)
		? thirdPartyConfigs[product]?.impersonationEnabled
		: false);
};
